import React, { useCallback } from 'react';
import { PageHeader, PageWrapper } from '../components/partials';
import { Spinner } from '../components/widgets';
import NetworkGrid from './components/NetworkGrid';
import EditShelf from './components/EditShelf';
import css from './styles.pcss';

const AudienceDistributions = props => {
    const {
        editError,
        loading,
        networks,
        segments,
        search,
        companyLogo,
        edit,
        saving,
        onEditChange,
        onEditSegmentStart,
        onEditSegmentChange,
        onEditSegmentSave,
        onEditSegmentCancel,
        adminMode,
        onSearch,
        onEditStart,
        onEditCancel,
        onEditConfirm,
        onToggleAdAccount,
        onManualRun,
        companyName,
        readOnly,
    } = props;

    const editStart = useCallback(
        network => {
            onEditStart(network);
        },
        [onEditStart]
    );

    const editCancel = useCallback(() => {
        onEditCancel(edit);
    }, [onEditCancel, edit]);

    const editConfirm = useCallback(() => {
        onEditConfirm(edit);
    }, [onEditConfirm, edit]);

    const toggleAdAccount = useCallback(
        (account, active) => {
            onToggleAdAccount(edit.name, account, active);
        },
        [onToggleAdAccount, edit && edit.name]
    );

    const manualRun = useCallback(() => {
        if (adminMode && edit.distribution.id) {
            if (window.confirm(`Are you sure you want to manually run ${edit.display_name} for ${companyName}?`)) {
                onManualRun(edit.distribution.id);
            }
        }
    }, [
        adminMode,
        edit && edit.distribution && edit.distribution.id,
        edit && edit.display_name,
        companyName,
        onManualRun,
    ]);

    let editErrorMessage = editError || null;
    if (!editError && edit?.distribution?.login_error_message) {
        editErrorMessage = (
            <span>
                <strong>Login Error:</strong> Failed to access {edit.display_name}.
                <br />
                <strong>Raw response received from the Network:</strong> {edit.distribution.login_error_message}
            </span>
        );
    }

    if (loading) {
        return <Spinner show expanded />;
    }
    return (
        <PageWrapper className={css.pageWrapper}>
            <PageHeader
                text="STATIC.PAGE_HEADERS.AUDIENCE_DISTRIBUTIONS"
                subText={{
                    faqLink: 'https://support.singular.net/hc/en-us/articles/360025454492-Audiences-FAQ',
                }}
            />
            <div className={css.pageDivider} />
            <NetworkGrid networks={networks} companyLogo={companyLogo} editStart={editStart} readOnly={readOnly} />
            <EditShelf
                adminMode={adminMode}
                manualRun={manualRun}
                editCancel={editCancel}
                editConfirm={editConfirm}
                editChange={onEditChange}
                toggleAdAccount={toggleAdAccount}
                editError={editErrorMessage}
                saving={saving}
                edit={edit}
                segments={segments}
                editSegmentStart={onEditSegmentStart}
                editSegmentChange={onEditSegmentChange}
                editSegmentSave={onEditSegmentSave}
                editSegmentCancel={onEditSegmentCancel}
                readOnly={readOnly}
            />
        </PageWrapper>
    );
};

AudienceDistributions.propTypes = {};

export default AudienceDistributions;
